import { getShowConfirmationPage } from '../../../selectors/tools';
import { useSelector } from 'react-redux';
import DTRBIIssueCouponAndRefundThenSendMacroNode from '../NodeGroups/DTCopyTextSendMacro/DTRBIIssueCouponAndRefundThenSendMacroNode/DTRBIIssueCouponAndRefundThenSendMacroNode';

const RbiIssueCouponAndRefundThenSendMacro = () => {
  const showConfirmationPage = useSelector(getShowConfirmationPage);

  return (
    <DTRBIIssueCouponAndRefundThenSendMacroNode
      showConfirmation={showConfirmationPage}
      message={'The coupon has been issued and the refund has been processed.'}
    />
  );
};

export default RbiIssueCouponAndRefundThenSendMacro;
